var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuRegistration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NarcRegistration",
    transform: "translate(-14708.565 16170.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2937",
    "data-name": "Rectangle 2937",
    transform: "translate(14708.565 -16170.466)",
    fill: "#e4efff",
    stroke: "#393939",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 6.909,
    rx: 3.455,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 5.909,
    rx: 2.955,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2938",
    "data-name": "Rectangle 2938",
    transform: "translate(14708.565 -16162.103)",
    fill: "#e4efff",
    stroke: "#393939",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 6.909,
    rx: 3.455,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 5.909,
    rx: 2.955,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53460",
    "data-name": "Group 53460",
    transform: "translate(14711.248 -16160.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25284",
    "data-name": "Path 25284",
    d: "M14528.5-16104.932h3.5",
    transform: "translate(-14528.5 16106.377)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25285",
    "data-name": "Path 25285",
    d: "M14533.875-16113.531l-2.025,3",
    transform: "translate(-14531.213 16113.531)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25286",
    "data-name": "Path 25286",
    d: "M14533.85-16113.332l1.569,3",
    transform: "translate(-14532.833 16113.37)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53461",
    "data-name": "Group 53461",
    transform: "translate(14716.382 -16160.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25284-2",
    "data-name": "Path 25284",
    d: "M14528.5-16104.932h3.5",
    transform: "translate(-14528.5 16106.377)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25285-2",
    "data-name": "Path 25285",
    d: "M14533.875-16113.531l-2.025,3",
    transform: "translate(-14531.213 16113.531)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25286-2",
    "data-name": "Path 25286",
    d: "M14533.85-16113.332l1.569,3",
    transform: "translate(-14532.833 16113.37)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53462",
    "data-name": "Group 53462",
    transform: "translate(14721.326 -16160.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25284-3",
    "data-name": "Path 25284",
    d: "M14528.5-16104.932h3.5",
    transform: "translate(-14528.5 16106.377)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25285-3",
    "data-name": "Path 25285",
    d: "M14533.875-16113.531l-2.025,3",
    transform: "translate(-14531.213 16113.531)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25286-3",
    "data-name": "Path 25286",
    d: "M14533.85-16113.332l1.569,3",
    transform: "translate(-14532.833 16113.37)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53463",
    "data-name": "Group 53463",
    transform: "translate(14726.27 -16160.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25284-4",
    "data-name": "Path 25284",
    d: "M14528.5-16104.932h3.5",
    transform: "translate(-14528.5 16106.377)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25285-4",
    "data-name": "Path 25285",
    d: "M14533.875-16113.531l-2.025,3",
    transform: "translate(-14531.213 16113.531)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25286-4",
    "data-name": "Path 25286",
    d: "M14533.85-16113.332l1.569,3",
    transform: "translate(-14532.833 16113.37)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_826",
    "data-name": "Ellipse 826",
    cx: 3.636,
    cy: 3.636,
    r: 3.636,
    transform: "translate(14716.929 -16153.738)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25287",
    "data-name": "Path 25287",
    d: "M14565.9-16064.371l1.406,1.293,2.054-2.054",
    transform: "translate(152.859 -85.823)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuRegistration);
export default __webpack_public_path__ + "static/media/menu-registration.237d8d18f0f3d3b914bff1bcfdc0dfe9.svg";
export { ForwardRef as ReactComponent };